import React from "react";

const Lines = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1480"
    height="177"
    viewBox="0 0 1480 177"
  >
    <path
      fill="none"
      stroke="#FFF"
      strokeOpacity=".1"
      d="M1480 0 1439.40086 0C1426.1468 0 1415.40266 10.7452 1415.40266 24L1415.40266 62C1415.40266 75.2548 1404.65831 86 1391.40435 86L0 86M1480 175 1439.40086 175C1426.1468 175 1415.40266 164.255 1415.40266 151L1415.40266 113C1415.40266 99.745 1404.65831 89 1391.40435 89L0 89"
      transform="translate(0 1)"
    />
  </svg>
);

export default Lines;
